import {MouseEvent} from 'react';

/**
 * Checks if a mouse event occured over a target DOM element.
 *
 * @param event the mouse event
 * @param rect the DomRect to check against
 * @returns {boolean} true of the mouse event occured over the DOMRect, false if it was outside the DOMRect
 */
export const mouseIsOverElement = (
  event: globalThis.MouseEvent | MouseEvent<HTMLElement>,
  rect: DOMRect
): boolean => {
  const {clientX, clientY} = event;
  const {left, right, top, bottom} = rect;

  return (
    clientX >= left && clientX <= right && clientY >= top && clientY <= bottom
  );
};
